const theme = {
  white: "#f5f5f5",
  black: "#202124",
  orange: "#ff7a00",
  red: "#fe2020",
  pink: "#ff3a75",
  yellow: "#FEE500",
  purple: "#535CE8",
  gray: "#D3D3D3",
  green: "#0FBD00",
  blue: "#535CE8",
  icon: {
    white: "rgba(255, 255, 255, 0.01)",
    hover: "rgba(255, 255, 255, 0.1)",
  },
  album: {
    white: "#eee",
    black: "#363636",
  },
  modal: {
    dim: "rgba(0, 0, 0, 0.87)",
    black: "#303134",
    gray: "#424755",
    lightGray: "#6f7486",
  },
};

export default theme;
